import { green, yellow, red } from '@mui/material/colors';

import { UseSearchParamsParameters } from '@occc-app/hooks/useSearchParams';

export const STORES_SUBMITTED_SEARCH_PARAMS: UseSearchParamsParameters = {
  searchParamName: 'stores-submitted-search',
  beforeParamName: 'stores-submitted-before',
  afterParamName: 'stores-submitted-after',
};

export const MISSING_STORES_SEARCH_PARAMS: UseSearchParamsParameters = {
  searchParamName: 'missing-stores-search',
  beforeParamName: 'missing-stores-before',
  afterParamName: 'missing-stores-after',
};

export const TRANSACTIONS_REPORTED_SEARCH_PARAMS: UseSearchParamsParameters = {
  searchParamName: 'transactions-reported-search',
  beforeParamName: 'transactions-reported-before',
  afterParamName: 'transactions-reported-after',
};

export const REIMBURSEMENTS_SEARCH_PARAMS: UseSearchParamsParameters = {
  searchParamName: 'reimbursements-search',
  beforeParamName: 'reimbursements-before',
  afterParamName: 'reimbursements-after',
};

export const SHOW_CENTS_THRESHOLD = 1000;
export const CHART_HEIGHT = 180;

const COLOR_SHADE = 700;

export const MISSING_STORES_GREEN_BAR_COLOR = green[COLOR_SHADE];
export const MISSING_STORE_YELLOW_BAR_COLOR = yellow[COLOR_SHADE];
export const MISSING_STORES_RED_BAR_COLOR = red[COLOR_SHADE];

// Missing stores percentage thresholds
export const MISSING_STORES_LOW_THRESHOLD = 5;
export const MISSING_STORES_MEDIUM_THRESHOLD = 11;
